import React from 'react';
import { Check, CheckCircle2 } from 'lucide-react';
export function BeneficiosIdeal() {
  return <section id="beneficios" className="py-8 sm:py-16 bg-[#0a1628] border-t border-gray-800" data-id="element-13">
      <div className="max-w-5xl mx-auto px-3 sm:px-6" data-id="element-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8" data-id="element-15">
          {/* Left Column: Ideal Para */}
          <div className="bg-[#1e293b]/60 p-4 sm:p-6 rounded-xl border border-gray-700/50" data-id="element-16">
            <h3 className="text-lg sm:text-2xl font-bold text-white mb-4 sm:mb-6 border-b border-gray-700 pb-3" data-id="element-17">
              Este kit es ideal para:
            </h3>
            <ul className="space-y-2 sm:space-y-3" data-id="element-18">
              {['Docentes de Metodología en Orientación en Ciencias Sociales', 'Profesores de 5° y 6° año', 'Docentes que trabajan en varias instituciones', 'Educadores que buscan estructura anual clara', 'Profesores que quieren elevar el nivel académico'].map((item, index) => <li key={index} className="flex items-start" data-id="element-19">
                  <div className="flex-shrink-0 bg-blue-500/20 rounded-full p-1 mr-3 mt-0.5" data-id="element-20">
                    <Check className="h-4 w-4 text-blue-400" strokeWidth={3} data-id="element-21" />
                  </div>
                  <span className="text-sm sm:text-base text-gray-200" data-id="element-22">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Right Column: Beneficios */}
          <div className="bg-[#1e293b]/60 p-4 sm:p-6 rounded-xl border border-gray-700/50" data-id="element-23">
            <h3 className="text-lg sm:text-2xl font-bold text-white mb-4 sm:mb-6 border-b border-gray-700 pb-3" data-id="element-24">
              Beneficios del Kit
            </h3>
            <ul className="space-y-2 sm:space-y-3" data-id="element-25">
              {['Sistema completo organizado por unidades', '25 proyectos sociales actuales listos', 'Enfoque mixto real (cuantitativo + cualitativo)', 'Análisis correlacional aplicado', 'Introducción a análisis multivariable', 'Planificación anual resuelta', 'Ahorro real de tiempo'].map((item, index) => <li key={index} className="flex items-start" data-id="element-26">
                  <div className="flex-shrink-0 bg-green-500/20 rounded-full p-1 mr-3 mt-0.5" data-id="element-27">
                    <CheckCircle2 className="h-4 w-4 text-[#16a34a]" strokeWidth={3} data-id="element-28" />
                  </div>
                  <span className="text-sm sm:text-base text-gray-200 font-medium" data-id="element-29">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}